import { useEffect, useRef, useState } from "react";
import i18n from "./i18n";

export function isDrawer(mtlType, model) {
    const compatibleMtl = ["fabric", "leather"];
    const compatibleType = ["bedroomStorage", "mediaConsole", "buffet"];

    return compatibleMtl.includes(mtlType) && compatibleType.includes(model.type) && model.drawers?.active;
}

export function getDrawerType(model, mtls) {
    // console.log(model.model.category)
    const fModel = model.model.category.map((el) => ({ mtls: el.materials, id: el.id, drawerPart: el.drawerPart })).filter(el => el.drawerPart === "front");
    const fOpt = fModel.find(el => model.option.category.includes(el.id))?.mtls || [];
    return fOpt.length > 1 ? fOpt.find(el => Object.keys(mtls).includes(el)) : fOpt[0];
}

export function getMaterialByID(materials, id) {
    let mtl = materials.find(el => el.id === id);
    return mtl;
}
export function getMaterialBySKU(materials, SKU) {
    let mtl = materials.find(el => el.SKU === SKU);
    return mtl;
}

export function findSimilarWoodMtl(materials, currMtl, tag = [""]) {
    const remapTag = tag.map(el => el.split("_")[1]);
    let mtl = materials.find(el => el.SKU === currMtl)?.name.en.toLowerCase().replace("birch", "").replace("oak", "").replace("walnut", "");
    let wantedMtl = materials.filter(el => !el.archived && el.tags.some(sl => remapTag.includes(sl)))
        .find(el => el.name.en.toLowerCase().replace("birch", "").replace("oak", "").replace("walnut", "").includes(mtl)) || materials.filter(el => !el.archived && el.tags.includes(tag))[0];
    return wantedMtl;
}

export function getModelBySKU(models, SKU, optSKU) {
    let model = models.find(el => el.SKU === SKU);
    const goodOptSKU = optSKU || model.defaultOption || model.furnitures[0].SKU;
    let option = model.furnitures?.find(el => el.SKU == goodOptSKU) || model.furnitures[0];
    return { model, option };
}

export function correctedSubCat(cat, woodException = [], tagToRemove) {
    let rtn = [...cat];
    if (cat.includes("fabric")) {
        rtn = ["fabric_pf", ...rtn]
    }
    if (cat.includes("wood")) {
        rtn = ["wood_bo", "wood_bm", "wood_bn", "wood_wv"]
    }
    if (cat.includes("porcelain")) {
        rtn = [...rtn, "porcelain_dk"]
    }
    if (cat.includes("glass")) {
        rtn = [...rtn, "glass_mi"]
    }
    const mtlRtn = woodException.length > 0 && cat.includes("wood") ? [...woodException] : rtn;
    return mtlRtn.filter(cat => !tagToRemove.includes(cat.split("_")[1]));
}

export const materialsOrder = [
    "fabric_pf",
    "fabric",
    "leather",
    "wood",
    "metal",
    "glass",
    "glass_mi",
    "porcelain",
    "porcelain_dk"
];

export const possibleCombo = [
    ["fabric", "leather"],
    ["glass", "porcelain"]
]

export const mtlTags = {
    fabric_pf: { id: "pf", name: "Performance" },
    fabric: { id: "fa", name: "Tissus" },
    leather: { id: "fl", name: "Faux cuirs" },
    leather_le: { id: "le", name: "Cuirs" },
    metal: { id: "me", SKU: "metal", name: "Finis de peinture" },
    wood: { id: "sw", SKU: "wood", name: "Bois massif" },
    wood_bo: { id: "bo", name: "Bois (Chêne)" },
    wood_bm: { id: "bm", name: "Bois (Merisier)" },
    wood_bn: { id: "bn", name: "Bois (Noyer)" },
    wood_wv: { id: "wv", name: "Placages de bois" },
    porcelain: { id: "po", SKU: "porcelain", name: "Porcelaines" },
    porcelain_dk: { id: "dk", name: "Dektons" },
    glass: { id: "gl", name: "Verres" },
    glass_mi: { id: "mi", name: "Miroirs" },
};

export function getThumbnail(material, type = "normal") {
    if (type === "pdf") {
        return `./images/thumbnails/pdf/${material?.type}/${material?.name.en.toLowerCase().replace(/-/g, "").replace(/\s+/g, "_").replace(/_+/g, "_")}.jpg`
    } else {
        return `./images/thumbnails/materials/${material?.type}/${material?.name.en.toLowerCase().replace(/-/g, "").replace(/\s+/g, "_").replace(/_+/g, "_")}.webp`
    }
}

export function duplicateKey(source, key, times = 2) {
    const result = { ...source };
    delete result[key]; // on enlève l’ancienne clé

    for (let i = 1; i <= times; i++) {
        result[`${key}${i}`] = source[key];
    }
    return result;
}
// ------------------------------------------------------------ Code Section
const encodingCode = {
    "mo": "model",
    "op": "option",
    "du": "duoton",
    "st": "style",
    "m": "metal",
    "p": "porcelain",
    "w": "wood",
    "g": "glass",
    "f": "fabric",
    "l": "leather",
    "f1": "fabric1",
    "l1": "leather1",
    "f2": "fabric2",
    "l2": "leather2",
}

const reverseEncoding = Object.fromEntries(
    Object.entries(encodingCode).map(([short, long]) => [long, short])
);

export function decodeCode(code) {
    const arr = code.split("_");
    const spl = arr.map(el => {
        const m = el.split("-");
        const key = encodingCode[m[0]];
        return (
            { [key]: m[1] }
        )
    });
    return spl.reduce(
        (acc, obj) => {
            const key = Object.keys(obj)[0];
            const value = obj[key];

            if (key === "model" || key === "option") {
                acc.model[key] = value;
            } else if (key === "duoton") {
                acc.duotonChoice = value;
            } else if (key === "style") {
                acc.style = value;
            } else {
                acc.materials[key] = value;
            }

            return acc;
        },
        { model: {}, materials: {}, duotonChoice: "mono" }
    );
    // const model = Object.entries(materials).filter((el))=>);

}

export function encodeCode(model, materials, duotonChoice, style) {
    const mo = "mo-" + model.model.SKU;
    const op = "op-" + model.option.SKU;
    const du = "du-" + duotonChoice;
    const st = "st-" + style;
    const mod = style ? [mo, op, du, st] : [mo, op, du];

    const mtl = Object.entries(materials).map(
        ([key, value]) => `${reverseEncoding[key]}-${value.code}`
    );

    const str = [...mod, ...mtl]

    return str.join("_");
}
// ------------------------------------------------------------ Code Section END

// ------------------------------------------------------------ Filters Section
export function getMaterialExceptions(model) {
    const optMtlExeptions = model.option.mtlExceptions ? Object.values(model.option.mtlExceptions).flat() : [];
    return [...Object.values(model.model.mtlExceptions).flat(), ...optMtlExeptions];
}

export function getFilteredTags() {

}

export const woodCompatible = (code, modelSKU) => {
    const c = code.substring(4);
    let rtn;
    switch (c) {
        case "O":
        case "BOO":
        case "BTO":
            rtn = ["wood_bo"];
            break;
        case "BS":
        case "BOB":
        case "BTB":
        case "BR":
            rtn = ["wood_bm"];
            break;
        default:
            // Exception avec Lit City...
            if (modelSKU === "CI") {
                if (code.includes("B")) {
                    rtn = ["wood_bo", "wood_bm"]
                } else {
                    rtn = ["wood_wv"]
                }
            } else {
                rtn = ["wood_wv"]
            }
    }
    return rtn;
}

export function findModelByFilters(currFilters, models) {
    let rtn = models.find(el => arraysEqual(el.filters, currFilters));
    return rtn;
}

export function findGoodFilters(currFilters, models) {
    const arr = [];
    models.map(el => arr.push(el.filters))
    // let filters = allFilters.map(el => {
    //     el.choices.map(l => arr[el.id] = l.id)
    // });
    let rtn = findBestOneDifference(currFilters, arr);
    // console.log(currFilters, arr, rtn)
    return rtn;
}

export function makeFilterNamePDF(selectedIds, options) {
    const filters = selectedIds.map((choiceId, index) => {
        // Trouver le bloc correspondant (id == index)
        const optionBlock = options.find(opt => opt.id === index);
        if (!optionBlock) return null;

        // Trouver le choix correspondant (id == choiceId)
        const choice = optionBlock.choices.find(c => c.id === choiceId);
        return choice || null;
    }).filter(Boolean); // enlever les null
    return filters.map(el => el.name[i18n.language]).filter(el => el !== "N/A").join(" - ");
}

export function getGoodCategories(model, duotonMode, categories) {
    const duoton = model.model?.duoton;
    const type = model.model?.type;
    const ovveride = model.model?.nameDuoton;
    if (!duoton) { return categories }
    // console.log(categories)
    const f = categories?.filter(l => !l.materials.includes("fabric")) ?? [];
    const fabCat = categories?.filter(l => l.materials.includes("fabric") || l.materials.includes("leather"))?.[0]?.materials ?? [];
    // console.log(categories?.filter(l => l.materials.includes("fabric") || l.materials.includes("leather")).materials)
    let goodName = {};
    if (duotonMode === "mono") {
        goodName = { fr: "Rembourrage", en: "Upholstery" };
    } else {
        goodName.one = ovveride?.one.fr ? ovveride?.one : { fr: type === "bed" ? "Lit" : "Assise et intérieur de dossier", en: type === "bed" ? "Bed" : "Seat and inside back" };
        goodName.two = ovveride?.two.fr ? ovveride?.two : { fr: type === "bed" ? "Têtières" : "Extérieur de dossier", en: type === "bed" ? "Headboard pillows" : "Outside back" };
    }
    // Triton ** Coming soon! **
    /*else{

    }*/
    const choices = duotonMode === "mono" ?
        [
            {
                id: 1,
                materials: fabCat,
                name: goodName
            }
        ]
        :
        [
            {
                id: 1,
                materials: fabCat,
                name: goodName.one
            },
            {
                id: 2,
                materials: fabCat,
                name: goodName.two
            },
        ]

    return [...f, ...choices];
}


// --------- UTILS ---------
function arraysEqual(a, b) {
    return a.length === b.length && a.every((val, i) => val === b[i]);
}

function findBestOneDifference(curr, arrays) {
    let best = null;
    let bestScore = -Infinity;

    for (const arr of arrays) {
        if (arr.length !== curr.length) continue;
        if (arr[0] !== curr[0]) continue; // doit garder la première valeur

        let diffCount = 0;
        let score = 0;

        for (let i = 0; i < curr.length; i++) {
            if (curr[i] !== arr[i]) {
                diffCount++;
            } else {
                // chaque correspondance ajoute un score pondéré
                score += (curr.length - i);
            }
        }

        // On choisit le modèle avec le moins de différences, puis le meilleur score
        const finalScore = -diffCount * 100 + score;

        if (finalScore > bestScore) {
            bestScore = finalScore;
            best = arr;
        }
    }

    return best;
}



// ----------------------------------------------------- Filters Section - [END]


/**
 * Vérifie si une image existe dans /public,
 * sinon retourne une image de fallback.
 *
 * @param {string} path - Chemin de l'image principale (depuis /public).
 * @param {string} fallback - Chemin de l'image de secours (depuis /public).
 * @returns {string} - L'URL valide de l'image.
 */
export function useBackgroundImageWithFallback(path, fallback) {
    const [image, setImage] = useState(fallback);

    useEffect(() => {
        if (!path) {
            setImage(fallback);
            return;
        }

        const img = new Image();
        img.src = path;

        img.onload = () => setImage(path);
        img.onerror = () => setImage(fallback);

        // cleanup (évite des fuites mémoire si le composant est démonté)
        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [path, fallback]);

    return image;
}

const loadedCache = new Set();

export function useLazyBackgroundImage(src, fallback) {
    const [bgImage, setBgImage] = useState(fallback);
    const [isFallback, setIsFallback] = useState(true);
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current || !src) return;

        // ✅ Empêche de recharger si déjà dans le cache
        if (loadedCache.has(src)) {
            setBgImage(src);
            setIsFallback(false);
            return;
        }

        let observer;
        let img;

        const loadImage = () => {
            img = new Image();
            img.src = src;

            img.onload = () => {
                loadedCache.add(src);
                setBgImage(src);
                setIsFallback(false);
            };

            img.onerror = () => {
                setBgImage(fallback);
                setIsFallback(true);
            };
        };

        observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        loadImage();
                        observer.disconnect();
                    }
                });
            },
            { threshold: 0.1 }
        );

        observer.observe(ref.current);

        return () => {
            if (observer) observer.disconnect();
            if (img) {
                img.onload = null;
                img.onerror = null;
            }
        };
    }, [src, fallback]);

    return [bgImage, ref, isFallback];
}

export function normalizeFractions(input) {
    if (!input) return input;

    const fractionMap = {
        '¼': ' 1/4',
        '½': ' 1/2',
        '¾': ' 3/4',
        '⅐': ' 1/7',
        '⅑': ' 1/9',
        '⅒': ' 1/10',
        '⅓': ' 1/3',
        '⅔': ' 2/3',
        '⅕': ' 1/5',
        '⅖': ' 2/5',
        '⅗': ' 3/5',
        '⅘': ' 4/5',
        '⅙': ' 1/6',
        '⅚': ' 5/6',
        '⅛': ' 1/8',
        '⅜': ' 3/8',
        '⅝': ' 5/8',
        '⅞': ' 7/8',
    };

    return input.replace(
        /[¼½¾⅐⅑⅒⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞]/g,
        match => fractionMap[match] || match
    );
}

export function normalizeFractionsPretty(input) {
    if (!input) return input;

    const fractionMap = {
        '¼': '1⁄4',
        '½': '1⁄2',
        '¾': '3⁄4',
        '⅐': '1⁄7',
        '⅑': '1⁄9',
        '⅒': '1⁄10',
        '⅓': '1⁄3',
        '⅔': '2⁄3',
        '⅕': '1⁄5',
        '⅖': '2⁄5',
        '⅗': '3⁄5',
        '⅘': '4⁄5',
        '⅙': '1⁄6',
        '⅚': '5⁄6',
        '⅛': '1⁄8',
        '⅜': '3⁄8',
        '⅝': '5⁄8',
        '⅞': '7⁄8',
    };

    return input.replace(
        /[¼½¾⅐⅑⅒⅓⅔⅕⅖⅗⅘⅙⅚⅛⅜⅝⅞]/g,
        match => fractionMap[match] || match
    );
}